module.exports = __webpack_public_path__ + "static/img/thumb_26.3802bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_26.png
// module id = G3Pf
// module chunks = 0